import { fromJS } from 'immutable'
import * as ACTIONS from './redux/actions'
import { getConfigDataServer } from '../config'
import {
  fetchUserModerationReports,
  updateUserModerationReport,
} from '.'

const log = console

export function getUserModerationReportGroupsHandler ({ after }) {
  return after([ACTIONS.GET_USER_MODERATION_REPORT_GROUPS], async ({ dispatch, state, action }) => {
    try {
      const { config, auth, userModeration } = state
      const { payload } = action
      const { data = {} } = payload
      const { p = 1, pp = 10 } = data
      const filter = userModeration.get('filter')
      const options = {
        auth,
        server: getConfigDataServer(config),
        filter,
        p,
        pp,
      }

      const reports = await fetchUserModerationReports(options)
      dispatch(ACTIONS.setUserModerationReportGroups({ data: fromJS(reports) }))
    } catch (error) {
      log.error(error, 'Error getting user moderation report group data')
    }
  })
}

export function updateUserModerationReportGroupHandler ({ after }) {
  return after(
    [ACTIONS.UPDATE_USER_MODERATION_REPORT_GROUP],
    async ({ state, dispatch, action }) => {
      try {
        const { config, auth } = state
        const { payload: { data } } = action
        const options = {
          auth,
          data,
          server: getConfigDataServer(config),
        }
        await updateUserModerationReport(options)
        dispatch(ACTIONS.getUserModerationReportGroups())
      } catch (error) {
        log.error(error, 'Error updating user moderation report group data')
      }
    },
  )
}

export function watchStatusFilterChange ({ after }) {
  return after([ACTIONS.SET_STATUS_FILTER], async ({ dispatch }) => {
    dispatch(ACTIONS.getUserModerationReportGroups())
  })
}
